import classes from './App.module.scss';

import Authorization from '@/pages/Authorization';
import Logout from '@/pages/Logout';
import Page404 from '@/pages/Page404';
import PageAddInference from '@/pages/PageAddInference';
import PageInferenceResults from '@/pages/PageInferenceResults';
import PageCentrifugeReports from '@/pages/PageCentrifugeReports';
import PageHome from '@/pages/PageHome';
import PageImportFiles from './pages/PageImportFiles';
import PageRigWell from './pages/PageRigWell';
import PageRigCalibration from './pages/PageRigCalibration';
import AuthGuard from '@/AuthGuard';
import AdminGuard from '@/AdminGuard';
import { Header } from '@/layout/header/Header';

import { AppShell } from '@mantine/core';

import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';

import { Route, Routes, useLocation } from 'react-router-dom';

export default function App() {
  const location = useLocation();
  const isLoginPage = location.pathname === '/authorization';

  return (
    <AppShell
      header={{ height: isLoginPage ? 64 : { base: 112, lg: 64 } }}
      className={classes.mainPage}
      padding={isLoginPage ? 0 : { base: 6, sm: 8, lg: 10 }}
    >
      <AppShell.Header withBorder={false}>
        <Header logoOnly={isLoginPage} />
      </AppShell.Header>

      <AppShell.Main w={'100%'} h={'100dvh'} className={classes.appMain}>
        <Routes>
          <Route element={<AuthGuard />}>
            <Route path="/rig_well" element={<PageRigWell />} />
            <Route
              path="/inference_results"
              element={<PageInferenceResults />}
            />
            <Route
              path="/centrifuge_reports"
              element={<PageCentrifugeReports />}
            />
            <Route element={<AdminGuard />}>
              <Route path="/" element={<PageHome />} />
              <Route path="/calibration/:id" element={<PageRigCalibration />} />
              <Route path="/add_inference" element={<PageAddInference />} />
              <Route path="/import_files" element={<PageImportFiles />} />
            </Route>
          </Route>
          <Route path="/authorization" element={<Authorization />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="*" element={<Page404 />} />
        </Routes>
      </AppShell.Main>
    </AppShell>
  );
}
